
import { defineComponent } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";

import Marketing from "@/components/1crm/sales/marketing/marketing.vue";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    Marketing,
  },
  props: {
    widgetClasses: String,
  },

  beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH_USER);
    setCurrentPageBreadcrumbs("Marketing", ["Data"]);
  },

});
